(function () {
    'use strict';

    function updateCapsLockWarning(e) {
        if (e.getModifierState) {
            let capsLockOn = e.getModifierState('CapsLock');
            document.getElementById('capslock-warning').style.display = capsLockOn ? '' : 'none';
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        let fields = document.querySelectorAll('[data-capslock="true"]');
        fields.forEach(function (field) {
            field.addEventListener('keydown', updateCapsLockWarning);
            field.addEventListener('keyup', updateCapsLockWarning);
            field.addEventListener('blur', function () {
                document.getElementById('capslock-warning').style.display = 'none';
            });
        });
    });
}());
